import { Routes } from '@angular/router';
import { CommonConstants } from './common/utilities/commonConstants';
import { HomeComponent } from './home/home.component';
import { ConfigResolve } from './common/services/config.resolve.service';
import { VehicleRegistrationComponent } from './vehicleRegistration/vehicleRegistration.component';
import { NonStpComponent } from './nonStp/nonStp.component';
import { MultitabFailedComponent } from './multitabFailed/multitabFailed.component';
import { AuthGuard } from './common/utilities/authGuard';
import { GeneralInsuranceComponent } from './app-home/general-insurance/general-insurance.component';
export const ROUTES: Routes = [
  { path: '', redirectTo: 'vehicleRegistration', pathMatch: 'full' },
  {
    path: CommonConstants.Routes.Home,
    component: HomeComponent,
    resolve: { config: ConfigResolve },
  },
  {
    path: CommonConstants.Routes.Application.VehicleRegistration,
    component: VehicleRegistrationComponent,
    resolve: { config: ConfigResolve },
    // AuthGaurd
    canActivate: [AuthGuard]
  },
  {
    path: CommonConstants.Routes.Application.VehicleDetails,
    loadChildren: () =>
      import('./applicationModule/application.module').then((m) => m.ApplicationModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.PlanListing.PlanProductListing,
    loadChildren: () =>
      import('./planListingModule/planListing.module').then((m) => m.PlanListingModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.PlanListing.BuyPolicyDetails,
    loadChildren: () =>
      import('./planListingModule/planListing.module').then((m) => m.PlanListingModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.OwnerDetails.OwnerDetails,
    loadChildren: () =>
      import('./ownerDetailsModule/ownerDetails.module').then((m) => m.OwnerDetailsModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.Application.MotorDetails,
    loadChildren: () =>
      import('./motorDetailsModule/motorDetails.module').then((m) => m.MotorDetailsModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.Application.Previouspolicydetail,
    loadChildren: () =>
      import('./previousPolicyModule/previousPolicy.module').then((m) => m.PreviousPolicyModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.Application.nomineeDetails,
    loadChildren: () =>
      import('./nomineeDetailsModule/nomineeDetails.module').then((m) => m.NomineeDetailsModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: '',
    loadChildren: () =>
      import('./finalModule/final.module').then((m) => m.FinalModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.FinalModule.Congratulations,
    loadChildren: () =>
      import('./finalModule/final.module').then((m) => m.FinalModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.FinalModule.PaymentFailed,
    loadChildren: () =>
      import('./finalModule/final.module').then((m) => m.FinalModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.CustomerLogin,
    loadChildren: () =>
      import('./customerLoginModule/customerLogin.module').then((m) => m.CustomerLoginModule),
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.otp,
    loadChildren: () =>
      import('./customerLoginModule/customerLogin.module').then((m) => m.CustomerLoginModule),
    resolve: { config: ConfigResolve }
  },
  // {
  //     path: CommonConstants.Routes.Reject,
  //     component: RejectApplicationComponent,
  //     resolve: { config: ConfigResolve }
  // },
  {
    path: CommonConstants.Routes.NonStp,
    component: NonStpComponent,
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.MultitabFailed,
    component: MultitabFailedComponent,
    resolve: { config: ConfigResolve }
  },
  {
    path: CommonConstants.Routes.generalInsurance,
    component: GeneralInsuranceComponent,
    resolve: { config: ConfigResolve }
  }
];
